import api from '../_api'
import { isEqual } from 'lodash-es'

export default {
  fetchMovements: async ({ getters, commit, dispatch }) => {
    if (getters.isCallingMovements) return
    try {
      const page = getters.movementsCurrentPage
      commit('setIsCallingMovements', true)
      const response = await api.getOfficeMovements(page)
      const lastPage = response.headers['pagination-last-page']
      commit('setMovements', response.data)
      commit('setMovementsLastPage', lastPage)
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'dashboard_fetch_movements_error' }, { root: true })
    } finally {
       commit('setIsCallingMovements', false)
    }
  },
  fetchBalanceInformation: async ({ getters, commit, dispatch }, officeId) => {
    if (getters.isCallingOffice || !officeId) return
    try {
      commit('setIsCallingOffice', true)

      const response = await api.getIssuerBalance(officeId)
      commit('setOfficeBalanceInformation', response.data)
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'office_fetch_issuer_balance_error' }, { root: true })
    } finally {
      commit('setIsCallingOffice', false)
    }
  },
  fetchTokenizedCards: async ({ getters, commit, dispatch }, officeId) => {
    if (getters.isCallingTokenizedCards || !officeId) return
    try {
      commit('setIsCallingTokenizedCards', true)
      const response = await api.getTokenizedCards(officeId)
      commit('setTokenizedCards', response.data.paymentData)
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'office_fetch_tokenized_cards_error' }, { root: true })
    } finally {
      commit('setIsCallingTokenizedCards', false)
    }
  },
  fetchExpenseDashboardData: async ({ getters, commit, dispatch }) => {
    try {
      let filters = Object.assign({}, getters.expenseDataFilters)
      const { data } = await api.getDashboardExpenses(filters)
      commit('setExpenseDashboardData', data)
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'dashboard_fetch_expense_dashboard_data_error' }, { root: true })
    }
  },
  setExpenseDataFilters: async ({ commit, getters, dispatch }, { filters, force = false }) => {
    if (!isEqual(filters, getters.expenseDataFilters) || force) {
      commit('setExpenseDataFilters', filters)
      await dispatch('fetchExpenseDashboardData')
    }
  },
  deleteTokenizedCard: async ({ getters, commit, dispatch }, { officeId, data }) => {
    if (getters.isCallingTokenizedCards || !officeId) return
    try {
      commit('setIsCallingTokenizedCards', true)
      await api.deleteTokenizedCard(officeId, data)
      const currentCards = [...getters['tokenizedCards']]
      commit('setTokenizedCards', currentCards.filter(card => card.mpT !== data.cardToken))
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'office_delete_tokenized_cards_error' }, { root: true })
    } finally {
      commit('setIsCallingTokenizedCards', false)
    }
  },
  clearStore: ({ commit }, payload) => {
    commit('clearStoreData', payload)
  },
  nextMovementsPage: ({ commit, dispatch }) => {
    commit('incrementMovementsCurrentPage')
    dispatch('fetchMovements')
  }

}
